import { HttpServiceBase } from "./http-service-base";
import { getLogger } from "../common/logging";
import * as env from "../../config/environment.json";
import { externalBaseUrl } from "../app-url";
let log = getLogger("application-service");

export class ApplicationService extends HttpServiceBase {
  constructor(...rest) {
    super(...rest);
  }

  list() {
    return new Promise((resolve, reject) => {
      this.http
        .get("/v1/applications")
        .then((data) => JSON.parse(data.response))
        .then((response) => resolve(response))
        .catch((e) => {
          super.handleError(e);
          reject(e);
        });
    });
  }

  version = "v2";
  // version = "http://localhost:9910";

  getApplication(id) {
    return new Promise((resolve, reject) => {
      this.http
        .get(`/v1/applications/${id}`)
        .then((data) => JSON.parse(data.response))
        .then((response) => resolve(response))
        .catch((e) => {
          super.handleError(e);
          reject(e);
        });
    });
  }

  getApplicationType(appType) {
    return new Promise((resolve, reject) => {
      this.http
        .get(`/v2/applications/application-type/${appType}`)
        .then((data) => JSON.parse(data.response))
        .then((response) => resolve(response))
        .catch((e) => log.error(e));
    });
  }

  getBySSN(appType, ssn) {
    return new Promise((resolve, reject) => {
      this.http
        .get(`/v2/applications/by-ssn?type=${appType}&ssn=${encodeURIComponent(ssn)}`)
        .then((data) => {
          if (data.statusCode === 204) return resolve(null);
          return resolve(JSON.parse(data.response));
        })
        .catch((e) => {
          log.error(e);
          resolve(null);
        });
    });
  }

  createApplication(sessionId, type) {
    return new Promise((resolve, reject) => {
      this.http
        .post("/v2/applications/create/", {
          sessionId: sessionId,
          type: type,
        })
        .then((data) => JSON.parse(data.response))
        .then((response) => resolve(response))
        .catch((e) => {
          super.handleError(e);
          reject(e);
        });
    });
  }

  submit(id, customer) {
    let printUrl = `${externalBaseUrl()}${customer}/applications/${id}/print/`;

    return new Promise((resolve, reject) => {
      this.http
        .post(`/v1/applications/${id}/submit`, { printUrl: printUrl })
        .then(() => resolve())
        .catch((e) => {
          super.handleError(e);
          reject(e);
        });
    });
  }

  setDescription(id, description) {
    let url = `/v1/applications/${id}/description`;
    return new Promise((resolve, reject) => {
      this.http
        .post(url, { description: description })
        .then((data) => JSON.parse(data.response))
        .then((response) => resolve(response))
        .catch((e) => {
          super.handleError(e);
          reject(e);
        });
    });
  }

  setApplicantName(id, applicantName) {
    let url = `/v1/applications/${id}/applicantName`;
    return new Promise((resolve, reject) => {
      this.http
        .post(url, { applicantName: applicantName })
        .then((data) => JSON.parse(data.response))
        .then((response) => resolve(response))
        .catch((e) => {
          super.handleError(e);
          reject(e);
        });
    });
  }

  changeSession(id, sessionId) {
    let url = `/v1/applications/${id}/changeSession`;
    return new Promise((resolve, reject) => {
      this.http
        .post(url, {
          sessionId: sessionId,
          comment: "",
          postpone: false,
          updateInfo: true,
        })
        .then((data) => JSON.parse(data.response))
        .then((response) => resolve(response))
        .catch((e) => {
          super.handleError(e);
          reject(e);
        });
    });
  }

  reprint(id) {
    return new Promise((resolve, reject) => {
      this.http
        .post(`/v1/print/${id}`, {})
        .then(() => resolve())
        .catch((e) => {
          super.handleError(e);
          reject(e);
        });
    });
  }

  delete(id) {
    let url = `/v1/applications/${id}`;
    return new Promise((resolve, reject) => {
      this.http
        .delete(url)
        .then(() => resolve())
        .catch((e) => {
          super.handleError(e);
          reject(e);
        });
    });
  }
}
